import { Progressable } from '../../Foundation';

/**
 * Progress
 * When user interacts with server, toggl overlay with spinner to indicate action is ongoing
 * NB! Only for use with webforms
 * @package Feature/Progress
 */
export class Progress {
  /**
   * Initialize handling eg. for component
   * @param {HTMLElement} el - current element
   */
  constructor(el) {
    this._refs = {
      el: el,
    };

    this._props = {
      manager: window.Sys.WebForms.PageRequestManager.getInstance(),
    };

    if (!this._settings.tagTypes.includes(this._type)) {
      throw Error('Progress: Given element is not suported by feature');
    }

    this._backdrop = new Progressable();
    this._refs.el.addEventListener('click', this._onProgressElementClick.bind(this));
    if (typeof this._props.manager !== 'undefined' && this._props.manager !== null) {
      this._onCallback();
    }
  }

  /**
   * Handler for initiating callback once user pressed element
   * @param {Event} e - Event interface
   */
  _onProgressElementClick(e) {
    if (e.target.classList.contains(this._settings.classnames.disabled)) {
      e.preventDefault();
    } else {
      e.target.classList.add(this._settings.classnames.disabled);
      this._backdrop.show();
    }
  }

  /**
   * Callback handler when used in context of updatepanels
   */
  _onCallback() {
    this._props.manager.add_endRequest((sender) => {
      let arrPanels = sender._updatePanelClientIDs,
        test = arrPanels.filter((panel) => {
          const oPanel = document.querySelector('#' + panel);
          if (oPanel != null && !!this._refs.el.id) {
            return oPanel.querySelector('#' + this._refs.el.id) != null;
          }

          return false;
        });

      if (test.length) {
        // trigger was found within panel
        document
          .querySelector('#' + this._refs.el.id)
          .addEventListener('click', this._onProgressElementClick.bind(this));
      }

      this._refs.el.classList.remove(this._settings.classnames.disabled);
      this._backdrop._remove();
    });
  }

  /**
   * Get current type of element for matching against allowed tags
   * @returns {String}
   */
  get _type() {
    return this._refs.el.tagName.toLowerCase();
  }

  /**
   * Get settings for feature
   */
  get _settings() {
    return {
      tagTypes: ['input', 'button', 'a'],
      classnames: {
        disabled: 'is-disabled',
      },
    };
  }
}
